import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconBuildingCommunity } from "@tabler/icons-react";
import { PersonalRecibosDef } from "./PersonalRecibosDef";

export const PersonalRecibosHelpText = "* Enviar recibos.";
export const PersonalRecibosIcon = IconBuildingCommunity;

export class PersonalRecibos extends Entity<PersonalRecibosDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new PersonalRecibosDef(), parentKeys);
        this.Form = import('./PersonalRecibosForm').then((module) => module.PersonalRecibosForm);
        this.Title = "Recibos de Sueldo";
        this.HelpText = PersonalRecibosHelpText;
        this.Icon = PersonalRecibosIcon;
    }
}